var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.999,
    height: 18,
    viewBox: "0 0 17.999 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5503",
    "data-name": "Rectangle 5503",
    width: 17.999,
    height: 18,
    fill: "none",
    stroke: "#fc3",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35464",
    "data-name": "Group 35464",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35463",
    "data-name": "Group 35463",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5502",
    "data-name": "Rectangle 5502",
    d: "M.667,0H15.533A.666.666,0,0,1,16.2.666V2.933a.667.667,0,0,1-.667.667H.667A.667.667,0,0,1,0,2.933V.667A.667.667,0,0,1,.667,0Z",
    transform: "translate(0.9 5.401)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_472",
    "data-name": "Line 472",
    y2: 11.7,
    transform: "translate(9 5.401)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39487",
    "data-name": "Path 39487",
    d: "M14.6,6.667v6.3a1.8,1.8,0,0,1-1.8,1.8h-9a1.8,1.8,0,0,1-1.8-1.8v-6.3",
    transform: "translate(0.7 2.334)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39488",
    "data-name": "Path 39488",
    d: "M4.25,5.166a2.25,2.25,0,1,1,0-4.5,3.243,3.243,0,0,1,2.442,1.21A7.632,7.632,0,0,1,8.3,5.166a7.632,7.632,0,0,1,1.608-3.29A3.243,3.243,0,0,1,12.35.667a2.25,2.25,0,1,1,0,4.5",
    transform: "translate(0.7 0.234)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/reward-icon.88696289f8df1b9623bfb2ca7cfc0e51.svg";
export { ForwardRef as ReactComponent };